import React from "react";
import PageBanner from "./PageBanner";
import RichText from "./RichText";

export interface PageHeroProps {
  kicker?: string;
  title?: React.ReactNode;
  text?: React.ReactNode;
  textHtml?: string | null;
  meta?: React.ReactNode;
  metaClassName?: string;
  className?: string;
  bannerClassName?: string;
  fallback?: boolean;
  children?: React.ReactNode;
}

const PageHero: React.FC<PageHeroProps> = ({
  kicker,
  title,
  text,
  textHtml,
  meta,
  metaClassName,
  className,
  bannerClassName,
  fallback,
  children,
}) => (
  <PageBanner className={bannerClassName} fallback={fallback}>
    <section className={`PageHero${className ? ` ${className}` : ""}`}>
      <div className="PageHero-copy">
        {kicker ? <p className="PageHero-kicker">{kicker}</p> : null}
        {title ? <h1 className="PageHero-title">{title}</h1> : null}
        {textHtml ? <RichText className="PageHero-text" html={textHtml} /> : null}
        {!textHtml && text ? <p className="PageHero-text">{text}</p> : null}
      </div>
      {meta ? (
        <div className={`PageHero-meta${metaClassName ? ` ${metaClassName}` : ""}`}>{meta}</div>
      ) : null}
      {children}
    </section>
  </PageBanner>
);

export default PageHero;
